import '@reown/appkit-ui/wui-chip-button'
import { PrepareConnectionResult, SignClientTypes } from '@reown/web-wallet-core'

import Spacer from '../Spacer'

import styles from './styles.module.css'

interface DomainVerifyProps {
  verifyContext: PrepareConnectionResult['verifyContext']
  peerMetadata?: SignClientTypes.Metadata
}

export function DomainVerify({ verifyContext, peerMetadata }: DomainVerifyProps) {
  // Don't show domain verification if proposer is a native app
  const nativeRedirect = peerMetadata?.redirect?.native
  if (nativeRedirect && !nativeRedirect.startsWith('http')) {
    return null
  }

  const { verified } = verifyContext

  if (verified.validation === 'VALID' && !verified.isScam) {
    return (
      <wui-semantic-chip
        type="success"
        href={verified.origin}
        text={new URL(verified.origin).hostname}
      ></wui-semantic-chip>
    )
  }

  return (
    <div className={styles.container}>
      <wui-semantic-chip
        type="warning"
        href={verified.origin}
        text={new URL(verified.origin).hostname}
      />
      <Spacer size="2" />
      <wui-text variant="md-regular" color="inherit" align="center">
        {verified.isScam
          ? 'Warning: This domain has been identified as a scam.'
          : "We couldn't verify this domain."}
      </wui-text>
      <wui-text variant="md-regular" color="inherit" align="center">
        Please proceed with caution.
      </wui-text>
    </div>
  )
}
